import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import logoSrc from '../../../img/logo_branding.svg';

import { useLanguage, useBrandingUrl } from '@mssgme/hooks';
import { LinkBlank } from '../LinkBlank';
import styles from './Branding.module.scss';

export function Branding({ className, animated = false }) {
    const lang = useLanguage();
    const brandingUrl = useBrandingUrl();
    const poweredBy = lang === 'ru' ? 'мы используем' : 'powered by';

    return (
        <div className={classNames(styles.root, className, styles.slideDown, animated ? styles.animated : null)}>
            <LinkBlank href={brandingUrl} className={styles.link}>
                <img src={logoSrc} alt="mssg.me logo" />
                <span className={styles.text}>
                    {poweredBy} <span className={styles.decorateText}>mssg.me</span>
                </span>
            </LinkBlank>
        </div>
    );
}

Branding.propTypes = {
    className: PropTypes.string,
    animated: PropTypes.bool,
};
